import { Users, Globe, Briefcase, TrendingUp, ArrowRight, MessageCircle, CheckCircle2 } from "lucide-react";

export default function ITStaffingIntro() {
  return (
    <section
      className="w-full py-16 md:py-20 lg:py-24 overflow-hidden"
      style={{ backgroundColor: "#ffffff" }}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          
          {/* Left Column - Content */}
          <div>
            {/* Global Badge */}
            <div className="inline-flex items-center gap-2 mb-4">
              <div className="w-2 h-2 bg-black rounded-full"></div>
              <p 
                className="text-sm font-medium uppercase tracking-wider"
                style={{ 
                  fontFamily: '"Open Sans", sans-serif',
                  fontSize: '14px',
                  fontWeight: 500,
                  color: '#081120'
                }}
              >
                Global IT Staffing Services
              </p>
            </div>

            {/* Main Heading */}
            <h1
              className="text-3xl md:text-4xl  font-semibold leading-tight mb-5"
              style={{ 
                fontFamily: 'Outfit, sans-serif',
                fontWeight: 600,
                color: '#081120'
              }}
            >
              IT Staffing & Technology Recruitment <span className="whitespace-nowrap">Services for</span> Growing Businesses
            </h1>

            {/* Subheading / Description */}
            <p
              className="text-lg md:text-xl leading-relaxed mb-8"
                style={{
                  fontFamily: '"Open Sans", sans-serif',
                  fontSize: '16px',
                  lineHeight: '180%',
                  hyphens: "none",
                  fontWeight: 400,
                  color: 'black',
                  textAlign: 'left',
                  opacity: 1,
                  transform: 'translate3d(0px, 0px, 0px)',
                }}
            >
              Hire vetted IT professionals and engineering teams with Kapil Tech's specialized technology recruitment services.
            </p>

            {/* Trust Indicators */}
            {/* <div className="flex flex-wrap gap-6 mb-8">
              <div className="flex items-center gap-2">
                <CheckCircle2 className="w-5 h-5" style={{ color: '#0058a9' }} />
                <span className="text-sm font-medium" style={{ color: '#081120' }}>98% Client Retention</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircle2 className="w-5 h-5" style={{ color: '#0058a9' }} />
                <span className="text-sm font-medium" style={{ color: '#081120' }}>48h Avg. Profile Delivery</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircle2 className="w-5 h-5" style={{ color: '#0058a9' }} />
                <span className="text-sm font-medium" style={{ color: '#081120' }}>10,000+ Tech Hires</span>
              </div>
            </div> */}

            {/* CTA Buttons */}
            <div className="flex flex-wrap gap-4">
              {/* Request Talent Button - Primary */}
              <a
                href="#Request-Talent-Form"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg transition-all duration-300"
                style={{
                  backgroundColor: '#081120',
                  color: 'white',
                  fontFamily: '"Open Sans", sans-serif',
                  fontSize: '15px',
                  fontWeight: 600,
                  transform: 'translateY(0)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.backgroundColor = '#1a2a3a';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.backgroundColor = '#081120';
                }}
              >
                Request Talent
                <ArrowRight className="w-4 h-4" />
              </a>

              {/* Speak to Expert Button - Secondary */}
              <a
                href="#Contact-Expert"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg transition-all duration-300"
                style={{
                  backgroundColor: 'transparent',
                  color: '#081120',
                  border: '2px solid #081120',
                  fontFamily: '"Open Sans", sans-serif',
                  fontSize: '15px',
                  fontWeight: 600,
                  transform: 'translateY(0)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.backgroundColor = '#f5f5f5';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.backgroundColor = 'transparent';
                }}
              >
                <MessageCircle className="w-4 h-4" />
                Speak to a Staffing Expert
              </a>
            </div>

            {/* Additional Trust Badge */}
            {/* <div className="mt-8 pt-6 border-t border-gray-100 flex items-center gap-6">
              <div className="flex items-center gap-2">
                <Globe className="w-4 h-4" style={{ color: '#555658' }} />
                <span className="text-xs" style={{ color: '#555658' }}>Global Talent Network</span>
              </div>
              <div className="flex items-center gap-2">
                <TrendingUp className="w-4 h-4" style={{ color: '#555658' }} />
                <span className="text-xs" style={{ color: '#555658' }}>Rapid Scale-up Support</span>
              </div>
            </div> */}
          </div>

          {/* Right Column - Image */}
          <div className="relative">
            <div
              className="overflow-hidden rounded-2xl shadow-xl"
              style={{
                backgroundColor: "#f8f9fa",
              }}
            >
              {/* Replace this img src with your actual image URL */}
              <img
                src="https://ik.imagekit.io/7wqj9br0b/KapilTech_Website_Staffing/Home/executive-touching-icon-social-network.jpg"
                alt="IT Staffing and Technology Recruitment Professional"
                className="w-full h-auto object-cover transition-all duration-500 hover:scale-[1.02]"
                loading="eager"
                onError={(e) => {
                  // Fallback if image fails to load
                  e.currentTarget.src = "https://placehold.co/600x400/f0f2f5/081120?text=IT+Staffing+Professional";
                }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Add subtle animation styles */}
      <style jsx>{`
        @keyframes pulse {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-8px); }
        }
        .animate-pulse {
          animation: pulse 3s ease-in-out infinite;
        }
      `}</style>
    </section>
  );
}